module.exports = __webpack_public_path__ + "img/down-bold-arrow.6a2cd360.svg";